var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account",
    transform: "translate(-138 -528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5328",
    "data-name": "Group 5328"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 128,
    height: 128,
    transform: "translate(138 528)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(6154 -7314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M179.068,283.466c-.259-16.6-5.431-31.694-14.626-42.623C155.3,229.982,142.912,224,129.554,224s-25.747,5.982-34.889,16.844c-9.186,10.917-14.355,25.99-14.625,42.569,5.194,2.6,26.69,12.622,49.514,12.622C154.234,296.035,174.251,286.074,179.068,283.466Z",
    transform: "translate(-6081.554 7672.995)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 24.762,
    cy: 24.762,
    rx: 24.762,
    ry: 24.762,
    transform: "translate(-5976.764 7842.97)",
    fill: "#90205d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.7f98a141.svg";
export { ForwardRef as ReactComponent };